import { z } from "zod";

export const schema = z
  .object({
    // MEMO: 2回目のsubmit時にreasonが空文字からnullに変換されてしまうためnull許容
    //       https://rejob.slack.com/archives/C013E4Q9PUM/p1732523266462549
    reason: z.string().nullable(),
    description: z.string().max(100, { message: "100文字以内で入力してください。" }),
  })
  .refine((input) => input.reason !== null && input.reason !== "", {
    path: ["reason"],
    message: "選択してください。",
  })
  .refine(
    (input) => {
      return input.reason !== "other" || (input.reason === "other" && input.description !== "");
    },
    {
      path: ["description"],
      message: "入力してください。",
    },
  );

export type FormInputs = z.output<typeof schema>;
